import React from "react";
import { GET } from "../frameworks/HttpClient";
import { URL_LAB } from "../constants/urls";


const defaultNofification = {
  pond: 0,
  tank: 0,
}

const REFETCH_INTERVAL_MILLISECOND = 300000

const MenuNotificationContext = React.createContext({});

export function useMenuNotificationContext() {
  return React.useContext(MenuNotificationContext);
}

export default function MenuNotificationProvider({ children }) {
  // global state สำหรับใช้จัดการ feature ที่ขึ้นกับ menu notification
  // component นี้ ถูกเรียกบน App.js ให้ component ล่าง ๆ เรียก MenuNotificationContext ได้
  // component อื่น ๆ เรียกใช้ state จาก useMenuNotificationContext
  // เช่น const { menuBadges, fetchMenuBadges } = useMenuNotificationContext();
  const [notification, setNotification] = React.useState({ ...defaultNofification })

  const fetchNotification =  async () => {
    try {
      const response = await GET(URL_LAB.LAB_ORDER_INPUT_ORDER)
      setNotification({...defaultNofification, ...response.data})
    } catch (error) {
      console.log(error.errorMessages)
    }
  }

  React.useEffect(() => {
    const interval = setInterval(() => {
      fetchNotification();
    }, REFETCH_INTERVAL_MILLISECOND);

    return () => clearInterval(interval);
  }, []);

  return (
    <MenuNotificationContext.Provider value={{ notification, fetchNotification }}>
      {children}
    </MenuNotificationContext.Provider>
  )
}
